<template>
	<el-date-picker
		ref="input"
		class="input-sigarus-date-picker"
		type="date"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		:clearable="false"
		value-format="dd/MM/yyyy"
		:picker-options="{firstDayOfWeek: 1}"
	/>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'InputSigarusDatePicker',
		props: {
			value: {
				default: ''
			},
			format: {
				type: String,
				default: 'dd/MM/yyyy'
			}
		},
		computed: {

			model: {

				get () {
					return this.value == '0000-00-00' || this.value == null ? "" : this.value
				},

				set (val) {
					console.log('set: ',val)
					this.$emit('input', val) 
					this.$emit('save', val)
				}

			}

		},
		methods: {

			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			select () { setTimeout(() => this.$refs.input.$children[0].$refs.input.select(), 200) }

		}
	}
</script>
